import React, { Component } from "react";
import {
    DataGrid,
    FilterRow,
    Editing,
    Column,
    Paging,
    Pager,
    FormItem,
    Lookup,
    StateStoring,
} from 'devextreme-react/data-grid';
import PaginaToolbar from '../../components/PaginaToolbar';
import { criarParametrosRefisDs } from "../../DataSources";
import UserInfo from "../../UserInfo";
import uiInfo from "../../ui-info";

const localStorageKey = "cadastroParametrosRefisGridState";

let _paramRefisCorrente = undefined;

export default class ParametrosRefisBox extends Component {
    constructor() {
        super();
        this._gridInstance = React.createRef();
        this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    }

    onAtualizandoRow(e) {
        e.cancel = true;
        this.props.history.push("refis/editar/" + e.data.id);
    }

    render() {
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <PaginaToolbar titulo="Parametros Refis" novoCb={this.novoParamRefis.bind(this)}>
                    <DataGrid
                        ref={grid => this._gridInstance = grid}
                        dataSource={criarParametrosRefisDs()}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        columnAutoWidth={true}
                        columnHidingEnabled={true}
                        focusedRowEnabled={true}
                        wordWrapEnabled={window.innerWidth < 800}
                        filterSyncEnabled={true}
                        onEditingStart={this.onAtualizandoRow}>
                        <FilterRow visible={true} />
                        <Editing allowDeleting={true} allowUpdating={true} useIcons={true} />
                        <Column dataField={'id'} caption={"ID"} width={'50px'} visible={false}/>
                        <Column dataField={'sequencial'} caption={"#"} width={'80px'} />
                        <Column dataField={'prefeituraId'} caption={"Prefeitura"} visible={false}>
                            <FormItem visible={false}></FormItem>
                        </Column>
                        <Column dataField={'dataInicial'} dataType={"date"} caption={"Data Inicial"} width={100}/>
                        <Column dataField={'dataFinal'} dataType={"date"} caption={"Data Final"} width={100}/>
                        <Column dataField={'lei'} caption={"Lei"} />
                        <Column dataField={'parcelaFixa'} caption={"Parcelas Fixas"} width={120}/>
                        <Column dataField={'entradaSobreTotalDebitosSemDescontosRefis'} caption={"Entrada S. Deb. Orig."} width={150}/>
                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }

    novoParamRefis() {
        let gridState = this._gridInstance.instance.state();
        localStorage.setItem(localStorageKey, JSON.stringify(gridState));
        this.props.history.push("refis/novo");
    }

}
